export enum InformativeDialog {
  CurrencySelection,
  InviteSuppliers,
  WelcomeMessage,
  ResendInviteSupplier,
  DeleteInviteSupplier,
  PatchSupplier,
}
